import React from 'react';
import { FDPrimaryActionButton } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { dataAttrs } from 'Helpers/Testing';

export const PageSubmitButton = ({
  Component, resource, disabled, ...rest
}) => {
  const { submitPageResource, setPageContentCollection, isPageContentLoading } = usePageContentContext();

  const onSubmit = async () => {
    const { response, error } = await submitPageResource();
    if (!error) {
      setPageContentCollection(response);
    }
  };

  if (!resource.meta().canSubmit()) {
    return null;
  }

  return (
    <Component
      {...rest}
      {...dataAttrs('submit-btn')}
      loading={isPageContentLoading}
      label={resource.attr('primaryActionLabel') || 'Continue'}
      onClick={onSubmit}
      disabled={disabled}
    />
  );
};

PageSubmitButton.defaultProps = {
  disabled: false,
  Component: FDPrimaryActionButton,
};

PageSubmitButton.propTypes = {
  resource: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  Component: PropTypes.object,
};
